import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/dataStudio/importer/dataStudioImporterSelectors';
import DataStudioService from 'src/modules/dataStudio/dataStudioService';
import fields from 'src/modules/dataStudio/importer/dataStudioImporterFields';
import { i18n } from 'src/i18n';

const dataStudioImporterActions = importerActions(
  'DATASTUDIO_IMPORTER',
  selectors,
  DataStudioService.import,
  fields,
  i18n('entities.dataStudio.importer.fileName'),
);

export default dataStudioImporterActions;